export const AUTH_SESSION_QUERY_KEY = ['auth', 'session'] as const;

/** Signed GET URL for the signed-in user's profile image (short TTL). */
export const AUTH_PROFILE_IMAGE_VIEW_QUERY_KEY = [
  'auth',
  'profileImageView',
] as const;

/** `sessionStorage` key for one-shot message after refresh failure / forced logout. */
export const AUTH_EXPIRED_FLASH_MESSAGE_KEY =
  'friends-for-life-auth-expired-flash';

/** Refresh access token this many ms before estimated expiry (when `accessTokenExpiresAt` is set). */
export const AUTH_TOKEN_PROACTIVE_REFRESH_BUFFER_MS = 5 * 60 * 1000;
